import { FieldReadFunction } from '@apollo/client';
import * as Schema from 'owa-graph-schema';
import { getConfiguration } from 'owa-userconfiguration-cache';

type UserConfigurationPolicy = {
    Query: {
        fields: {
            [P in 'userConfiguration']: {
                read: FieldReadFunction<Schema.Query[P], Schema.Query[P] | undefined>;
            };
        };
    };
};

let initialRender = true;

export const unblockBootResolvers = () => {
    initialRender = false;
};

export const createBootPolicies = (): UserConfigurationPolicy => ({
    Query: {
        fields: {
            userConfiguration: {
                read(existing, { args }) {
                    return initialRender ? getConfiguration(args?.id) : existing;
                },
            },
        },
    },
});
